/* eslint-disable import/prefer-default-export */
export const ID = 'QUESTIONS_LIST';
